import { getVariableOrThrow } from '../../../shared/utils';

const FETCH_TIMEOUT = 5000;

export const redirectToSSWebApp = (token, onError) => {
  const baseUrl = getVariableOrThrow('VUE_APP_SSWEBAPP_BASE_URL');
  const url = `${baseUrl}/api2/external_login/admin_hierarchy_jwt/`;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FETCH_TIMEOUT);

  fetch(url, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ token }),
    signal: controller.signal,
  })
    .then(() => {
      clearTimeout(timeoutId);
      window.location.href = baseUrl;
    })
    .catch((e) => {
      clearTimeout(timeoutId);
      console.error(e);
      onError(
        'Compulse OMS requires you to be connected to the company VPN. Please connect to the VPN and try again.',
      );
    });
};
